import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChalkboardTeacher,
  faUserGraduate,
  faCommentDots,
  faBook,
  faChartLine,
} from '@fortawesome/free-solid-svg-icons'

const MentoringDashboard = () => {
  // Sample mentoring data - in a real app, this would come from your backend
  const mentees = []
  const stats = [
    {
      id: 'active-mentees',
      title: 'Active Mentees',
      value: '0',
      icon: faUserGraduate,
      bgColor: 'bg-blue-50',
      textColor: 'text-blue-600',
    },
    {
      id: 'sessions-completed',
      title: 'Sessions Completed',
      value: '0',
      icon: faChalkboardTeacher,
      bgColor: 'bg-green-50',
      textColor: 'text-green-600',
    },
    {
      id: 'avg-rating',
      title: 'Average Rating',
      value: '0.0',
      icon: faChartLine,
      bgColor: 'bg-purple-50',
      textColor: 'text-purple-600',
    },
    {
      id: 'hours-mentored',
      title: 'Hours Mentored',
      value: '0',
      icon: faBook,
      bgColor: 'bg-orange-50',
      textColor: 'text-orange-600',
    },
  ]

  return (
    <div className="mentoring-dashboard p-6 max-w-7xl mx-auto">
      {/* Breadcrumb */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Mentoring Dashboard
        </h1>
        <p className="text-gray-600">
          Manage your mentoring relationships and track your impact on students.
        </p>
      </div>

      {/* Stats Overview */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {stats.map((stat) => (
          <div
            key={stat.id}
            className={`${stat.bgColor} ${stat.textColor} p-6 rounded-lg shadow-sm`}
          >
            <div className="flex justify-between items-center">
              <div>
                <h3 className="font-bold text-2xl">{stat.value}</h3>
                <p className="text-sm mt-1">{stat.title}</p>
              </div>
              <div className="rounded-full p-3 bg-white bg-opacity-60">
                <FontAwesomeIcon icon={stat.icon} className="text-xl" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
          <div className="flex items-center mb-4">
            <div className="rounded-full p-3 bg-blue-50 text-blue-600 mr-4">
              <FontAwesomeIcon icon={faUserGraduate} />
            </div>
            <h3 className="text-lg font-semibold">Mentee Management</h3>
          </div>
          <p className="text-gray-600 mb-4">
            View and manage your assigned mentees.
          </p>
          <button className="text-blue-600 hover:text-blue-700 font-medium">
            View Mentees →
          </button>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
          <div className="flex items-center mb-4">
            <div className="rounded-full p-3 bg-green-50 text-green-600 mr-4">
              <FontAwesomeIcon icon={faChalkboardTeacher} />
            </div>
            <h3 className="text-lg font-semibold">Schedule Sessions</h3>
          </div>
          <p className="text-gray-600 mb-4">
            Plan and schedule mentoring sessions.
          </p>
          <button className="text-green-600 hover:text-green-700 font-medium">
            Schedule Session →
          </button>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
          <div className="flex items-center mb-4">
            <div className="rounded-full p-3 bg-purple-50 text-purple-600 mr-4">
              <FontAwesomeIcon icon={faCommentDots} />
            </div>
            <h3 className="text-lg font-semibold">Discussion Board</h3>
          </div>
          <p className="text-gray-600 mb-4">
            Engage with your mentees in group discussions.
          </p>
          <button className="text-purple-600 hover:text-purple-700 font-medium">
            View Discussions →
          </button>
        </div>
      </div>

      {/* Mentee List */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-100">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center">
              <div className="rounded-full p-3 bg-orange-50 text-orange-600 mr-4">
                <FontAwesomeIcon icon={faUserGraduate} />
              </div>
              <h2 className="text-lg font-semibold">Your Mentees</h2>
            </div>
            <div className="flex gap-2">
              <button className="px-4 py-2 text-sm bg-gray-50 text-gray-600 rounded hover:bg-gray-100">
                Filter
              </button>
              <button className="px-4 py-2 text-sm bg-primary text-white rounded hover:bg-primary-dark">
                Add Mentee
              </button>
            </div>
          </div>

          {mentees.length === 0 ? (
            <div className="text-center py-12 text-gray-500">
              <div className="mb-4">
                <FontAwesomeIcon
                  icon={faUserGraduate}
                  className="text-4xl text-gray-300"
                />
              </div>
              <p className="mb-2">No mentees assigned yet</p>
              <p className="text-sm">Start by adding your first mentee</p>
            </div>
          ) : (
            <div className="divide-y divide-gray-100">
              {mentees.map((mentee) => (
                <div key={mentee.id} className="py-4">
                  {/* Mentee item content would go here */}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default MentoringDashboard
